/** Default decision field options when creating a New Decision Section (count N). */
export function buildDefaultDecisionOptions(count) {
  const n = Math.min(30, Math.max(1, Math.floor(Number(count)) || 0));
  const options = [];
  for (let i = 1; i <= n; i += 1) {
    options.push({
      value: `option${i}`,
      text: `Option ${i}`,
      goTo: "",
    });
  }
  return options;
}
